module.exports = __webpack_public_path__ + "static/media/logoIvace.4b1a21c3.webp";